import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_URI_API || "http://localhost:3333",
});

api.interceptors.request.use(async (config) => {
  if (config.skipAuth) {
    return config;
  }

  const token = localStorage.getItem("token-sbf");

  if (token !== "" && token !== null) {
    config.headers.Authorization = token;
  }
  return config;
});

export default api;
